import { RouteConfig } from 'vue-router';
import Loto from '@/views/web/loto/index.vue';
import HowToPlay from '@/views/web/how-to-play/index.vue';
import Results from '@/views/web/results/index.vue';
import FAQS from '@/views/web/faqs/index.vue';

const publicRoutes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Loto
  },
  {
    path: '/how-to-play',
    name: 'HowToPlay',
    component: HowToPlay
  },
  {
    path: '/results',
    name: 'Results',
    component: Results
  },
  {
    path: '/faqs',
    name: 'FAQS',
    component: FAQS
  }
];

export default publicRoutes;
